// extracted by mini-css-extract-plugin
export var actionButton = "_bm-1";
export var actionButtons = "_bm-2";
export var actions = "_bm-0";
export var aiUnread = "_bm-10";
export var alignCenter = "_bm-h";
export var backWrapper = "_bm-3";
export var cellContainer = "_bm-4";
export var checkboxContainer = "_bm-5";
export var contentContainer = "_bm-6";
export var contentHeader = "_bm-8";
export var conversationsTableWrapper = "_bm-s";
export var draftReplyBadgeContainer = "_bm-m";
export var dropdownItem = "_bm-b";
export var dropdownItemsContainer = "_bm-a";
export var dropdownTitle = "_bm-c";
export var errorIcon = "_bm-7";
export var filter = "_bm-d";
export var gray = "_bm-i";
export var headerActionButtons = "_bm-e";
export var headerCheckboxContainer = "_bm-f";
export var icon = "_bm-j";
export var menuContainer = "_bm-k";
export var noMoreTicketsIcon = "_bm-12";
export var noMoreTicketsSubText = "_bm-13";
export var oneLine = "_bm-l";
export var optionsButton = "_bm-n";
export var plus = "_bm-o";
export var portalButtonsWrapper = "_bm-g";
export var red = "_bm-p";
export var scrolledTop = "_bm-9";
export var search = "_bm-q";
export var selectedConversationsCount = "_bm-r";
export var spinner = "_bm-t";
export var strong = "_bm-u";
export var summaryCell = "_bm-v";
export var tableContainer = "_bm-11";
export var tagContainer = "_bm-w";
export var threeDots = "_bm-x";
export var twoLines = "_bm-y";
export var unread = "_bm-z";